(function () {
    'use strict';

    angular
        .module('vmis.volunteer')
        .controller('BackgroundChecksController', BackgroundChecksController);

    BackgroundChecksController.$inject = ['$scope', '$modal', '$stateParams', 'authentication', 'adminInfo', 'moment'];

    function BackgroundChecksController($scope, $modal, $stateParams, authentication, adminInfo, moment) {
        var vm = this;

        vm.isLoading = true;
        vm.sortColumn = 'date';
        vm.sortReverse = true;

        var index = 0;
        var limit = 100;

        vm.backgroundChecks = [];
        vm.masterUserId = parseInt($stateParams.id) || null;
        // Admin master user ID is used to check whether user can edit individual background checks that are theirs
        vm.adminMasterUserId = parseInt(adminInfo.adminMasterUserId) || null;
        // Use existence of adminMasterUserId (not undefined) as the official check
        // of whether admin is editing another user
        vm.adminEditing = angular.isNumber(vm.adminMasterUserId);
        // Additional information for modals
        vm.adminFullName = adminInfo.adminFullName || "";
        vm.adminEmail = adminInfo.adminEmail || "";

        vm.onClickDetails = onClickDetails;
        vm.onClickAddBackgroundCheck = onClickAddBackgroundCheck;
        vm.canUserEditBackgroundCheck = canUserEditBackgroundCheck;

        activate();

        function activate() {
            if (vm.adminEditing)
                getBackgroundChecks(vm.masterUserId);
            else
                getBackgroundChecks();
        }

        function getBackgroundChecks(id) {
            vm.isLoading = true;

            var params = {
                startingRowIndex: index,
                numberOfRows: limit
            };

            if (angular.isNumber(id)) {
                params.masterUserId = id;
            }

            return authentication.getVolunteerBackgroundChecks(params)
                .then(function (response) {
                    vm.backgroundChecks = response.volunteerBackgroundChecks.map(function (backgroundCheck) {
                        var bgc = backgroundCheck.backgroundCheck;
                        var checker = backgroundCheck.checkerInfo;
                        return {
                            id: bgc.volunteerBackgroundCheckId,
                            checkerMasterUserId: bgc.checkerMasterUserId,
                            date: moment(bgc.date, 'YYYY-MM-DD').toDate(),
                            validUntil: moment(bgc.dateValidUntil, 'YYYY-MM-DD').toDate(),
                            comment: bgc.note,
                            checker: {
                                firstName: checker.firstName,
                                lastName: checker.lastName,
                                // Sometimes (migrated data) BGCs don't have the adminProfile
                                // Leave row blank so it doesn't make a broken link, but details page will do this.
                                workEmail: checker.adminProfile ? checker.adminProfile.workEmail : ""
                            }
                        };
                    });

                    vm.isLoading = false;
                })
                .catch(function (error) {
                    error = error.error ? error.error : error;
                    $scope.$emit('records:alert', error);
                    vm.isLoading = false;
                });
        }

        function openDetailsModal(backgroundCheck, id) {
            var options = {
                templateUrl: 'app/components/volunteer/records/backgroundChecks/details/view.html',
                controller: 'BackgroundCheckDetailsController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    backgroundCheck: function () {
                        return backgroundCheck ? angular.copy(backgroundCheck) : {};
                    },
                    id: function () {
                        return id ? angular.copy(id) : null;
                    },
                    // If background check already exists, check if it can be edited. If not, making new one.
                    viewOnly: function () {
                        return backgroundCheck ? !canUserEditBackgroundCheck(backgroundCheck) : false;
                    },
                    adminInfo: function () {
                        return {
                            checkerFullName: vm.adminFullName,
                            checkerEmail: vm.adminEmail
                        };
                    }
                }
            };
            $modal.open(options)
                .result
                .then(function (result) {
                    vm.isLoading = true;

                    var msg = "";
                    if (result) {
                        var verb = "";
                        switch (result.action) {
                            case 'add':
                                verb = "added";
                                break;
                            case 'edit':
                                verb = "updated";
                                break;
                            case 'delete':
                                verb = "deleted";
                                break;
                            default:
                                msg = "Unrecognized action!";
                                break;
                        }

                        if (verb)
                            msg = "Background check successfully " + verb + "!";
                    }
                    else
                        msg = "Unrecognized action!";

                    $scope.$emit('records:success', msg);

                    if (vm.adminEditing)
                        getBackgroundChecks(id);
                    else
                        getBackgroundChecks();
                })
                .catch(function (error) {
                    // If modal is left by pressing "Escape", error is undefined.
                    if (error) {
                        error = error.error ? error.error : error;
                        $scope.$emit('records:alert', error);
                    }
                });
        }

        function onClickDetails(backgroundCheck) {
            if (vm.adminEditing){
                backgroundCheck.adminMasterUserId = vm.adminMasterUserId;
                openDetailsModal(backgroundCheck, vm.masterUserId);
            }
            else
                openDetailsModal(backgroundCheck);
        }

        function onClickAddBackgroundCheck() {
            if (vm.adminEditing)
                openDetailsModal(null, vm.masterUserId);
            //else
            //openDetailsModal();
        }

        function canUserEditBackgroundCheck(backgroundCheck) {
            return vm.adminEditing;
        }
    }
})();